import { VUEX_ASSIGNMENT_MUTATION_NAMES } from "@tt-app/constants";

const { ACTIVE_LIST, DETAILS, HISTORICAL_TOTAL, LIST, LOADING } = VUEX_ASSIGNMENT_MUTATION_NAMES;

const assignmentMutations = {
  [ACTIVE_LIST](state: any, { activeAssignments }: any) {
    state.active = activeAssignments;
  },
  [DETAILS](state: any, { assignment }: any) {
    state.details = assignment;
  },
  [HISTORICAL_TOTAL](state: any, { historicalTotal }: any) {
    state.historicalTotal = historicalTotal;
  },
  [LIST](state: any, { assignments, years }: any) {
    state.list = assignments;
    state.years = years;
  },
  [LOADING](state: any, load: boolean) {
    state.loading = load;
  }
};

export { assignmentMutations };
